import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DiscountCalculator from '../../components/DiscountCalculator'
const default_discount = {discount: 0, elements: [], includes_tax: true}
const ProductDiscount = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { selectedProducts, setSelectedProducts, assignDiscount, getProducts } = app.products
  const [ productdiscount, setProductDiscount ] = React.useState(default_discount)
  const closeForm = () => {
    setSelectedProducts(false)
    setProductDiscount(default_discount)
  }
  const updateDiscount = (discount_object) => {
    assignDiscount(discount_object)
    close()
  }
  const skus = (ps) => ps.reduce((pv, p) => pv ? `${pv}, ${p.sku}` : p.sku, false)
  const name = () => selectedProducts.length === 1? `Asignar descuento a: ${getProducts(selectedProducts)[0].name}`: `Asignar descuento a ${selectedProducts.length} productos con SKUs: (${skus(getProducts(selectedProducts))})`
  React.useEffect(() => {
    if(selectedProducts){
      const p = getProducts(selectedProducts)[0]
      const _productdiscount = {
        value: p.discount, 
        elements: p.discount_elements !== ""? p.discount_elements.split(",") : [],
        includes_tax: p.includes_tax
      }
      selectedProducts.length === 1? setProductDiscount(_productdiscount) : setProductDiscount(default_discount)
    }
  }, [selectedProducts])

  return (
    <Dialog onClose={closeForm} open={open}>
    {selectedProducts && 
      <React.Fragment>
        <DialogTitle>{name()}</DialogTitle>
        <DiscountCalculator title="Calcular descuento" label="Descuento" initial_object={productdiscount} submit={updateDiscount}/>
      </React.Fragment>
    }
    </Dialog>
  )
}
export default ProductDiscount